<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-app-bar app color="primary" dark height="88">
      <div class="d-flex align-center flex-shrink-0">
        <v-img
          alt="VendorProof Logo"
          height="25"
          width="245"
          class="mr-12"
          contain
          src="@/assets/logo-2x.png"
          transition="scale-transition"
        />
      </div>
    </v-app-bar>

    <v-container class="splash">
      <v-row>
        <v-col cols="12">
          <pt-sheet class="employee-monitoring-pitch">
            <div class="content-wrap mx-sm-12 my-12 mt-9">
              <v-container class="pt-6">
                <v-row justify="center" class="my-8">
                  <v-icon class="celebratory-image"
                    >$celebrationsAndEncouragement</v-icon
                  >
                </v-row>
                <v-row justify="center" class="my-8">
                  <h2>Vendor Set-Up Successful!</h2>
                </v-row>
                <v-row justify="center" class="my-8">
                  <p class="sub-heading">
                    Your submission for setting up a new vendor in VendorProof
                    was successful. The vendor will receive an email with
                    further instructions to complete enrollment in VendorProof.
                  </p>
                </v-row>
                <v-row justify="center" class="my-8">
                  <p class="sub-heading">
                    To set up another vendor, click the button below.
                  </p>
                </v-row>
                <v-row justify="center" class="my-8">
                  <v-btn
                    color="colorVpDarkGreen"
                    class="white--text px-8 start-over-button"
                    @click="startOver()"
                    >Set-Up New Vendor</v-btn
                  >
                </v-row>
              </v-container>
            </div>
          </pt-sheet>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PtSheet from "@/components/PtSheet.vue";

export default {
  data: function() {
    return {};
  },
  name: "vendorSetupConfirmation",
  created() {
    this.logEvent("Landed on Vendor Setup Confirmation Page");
  },
  methods: {
    startOver() {
      this.$router.push({ path: `/vendor-setup/${this.clientTag}` }); //todo this needs to route to /vendor-setup/client-tag
    }
  },
  props: {
    clientTag: {
      type: String
    }
  },
  components: { PtSheet }
};
</script>

<style lang="sass" scoped>
.celebratory-image
  width: 374px
  height: 240px

h2
  font-weight: bold
  font-size: 36px
  line-height: 45px
  color: $darker-grey

.sub-heading
  font-size: 24px
  line-height: 30px
  text-align: center
  color: #000000

.start-over-button.v-btn
  height: 48px

  ::v-deep .v-btn__content
    font-weight: bold
    font-size: 24px
    line-height: 30px
    margin-left: 15px
    margin-right: 7px
</style>
